'use strict'

const ValidateEmail = (email) => {
  const re = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/

  return re.test(email)
}

export default ValidateEmail
